import { IssueType } from '@fb/models/issues-type.model';

export const getIssueTypes = (): IssueType[] => [
  {
    id: 1,
    issueType: 'Task',
    fields: [
      {
        fieldId: 'attachment',
        fieldType: 'string',
        name: 'Attachment',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_10400',
        fieldType: 'string',
        name: 'User Security List',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'description',
        fieldType: 'string',
        name: 'Description',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'duedate',
        fieldType: 'string',
        name: 'Due Date',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'issuelinks',
        fieldType: 'string',
        name: 'Linked Issues',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'priority',
        fieldType: 'string',
        name: 'Priority',
        required: false,
        allowedValues: ['Blocker', 'High', 'Medium', 'Low', 'Minor'],
      },
      {
        fieldId: 'summary',
        fieldType: 'string',
        name: 'Summary',
        required: true,
        allowedValues: [],
      },
    ],
  },
  {
    id: 1,
    issueType: 'Sub-task',
    fields: [
      {
        fieldId: 'attachment',
        fieldType: 'string',
        name: 'Attachment',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_10400',
        fieldType: 'string',
        name: 'User Security List',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'description',
        fieldType: 'string',
        name: 'Description',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'duedate',
        fieldType: 'string',
        name: 'Due Date',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'issuelinks',
        fieldType: 'string',
        name: 'Linked Issues',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'parent',
        fieldType: 'string',
        name: 'Parent',
        required: true,
        allowedValues: [],
      },
      {
        fieldId: 'priority',
        fieldType: 'string',
        name: 'Priority',
        required: false,
        allowedValues: ['Blocker', 'High', 'Medium', 'Low', 'Minor'],
      },
      {
        fieldId: 'summary',
        fieldType: 'string',
        name: 'Summary',
        required: true,
        allowedValues: [],
      },
    ],
  },
  {
    id: 1,
    issueType: 'Service Request',
    fields: [
      {
        fieldId: 'attachment',
        fieldType: 'string',
        name: 'Attachment',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_10400',
        fieldType: 'string',
        name: 'User Security List',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'description',
        fieldType: 'string',
        name: 'Description',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'duedate',
        fieldType: 'string',
        name: 'Due Date',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'issuelinks',
        fieldType: 'string',
        name: 'Linked Issues',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'priority',
        fieldType: 'string',
        name: 'Priority',
        required: false,
        allowedValues: ['Blocker', 'High', 'Medium', 'Low', 'Minor'],
      },
      {
        fieldId: 'summary',
        fieldType: 'string',
        name: 'Summary',
        required: true,
        allowedValues: [],
      },
    ],
  },
  {
    id: 1,
    issueType: 'Hardware',
    fields: [
      {
        fieldId: 'attachment',
        fieldType: 'string',
        name: 'Attachment',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_10400',
        fieldType: 'string',
        name: 'User Security List',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_20379',
        fieldType: 'string',
        name: 'Affected User',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_20630',
        fieldType: 'string',
        name: 'Hardware',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'description',
        fieldType: 'string',
        name: 'Description',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'duedate',
        fieldType: 'string',
        name: 'Due Date',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'issuelinks',
        fieldType: 'string',
        name: 'Linked Issues',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'priority',
        fieldType: 'string',
        name: 'Priority',
        required: false,
        allowedValues: ['Blocker', 'High', 'Medium', 'Low', 'Minor'],
      },
      {
        fieldId: 'summary',
        fieldType: 'string',
        name: 'Summary',
        required: true,
        allowedValues: [],
      },
    ],
  },
  {
    id: 1,
    issueType: 'Software',
    fields: [
      {
        fieldId: 'attachment',
        fieldType: 'string',
        name: 'Attachment',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_10400',
        fieldType: 'string',
        name: 'User Security List',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_20378',
        fieldType: 'string',
        name: 'Software action',
        required: true,
        allowedValues: ['Install', 'Uninstall', 'Update', 'License'],
      },
      {
        fieldId: 'customfield_20379',
        fieldType: 'string',
        name: 'Affected User',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'description',
        fieldType: 'string',
        name: 'Description',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'duedate',
        fieldType: 'string',
        name: 'Due Date',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'issuelinks',
        fieldType: 'string',
        name: 'Linked Issues',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'priority',
        fieldType: 'string',
        name: 'Priority',
        required: false,
        allowedValues: ['Blocker', 'High', 'Medium', 'Low', 'Minor'],
      },
      {
        fieldId: 'summary',
        fieldType: 'string',
        name: 'Summary',
        required: true,
        allowedValues: [],
      },
    ],
  },
  {
    id: 1,
    issueType: 'ON Part1 HD',
    fields: [
      {
        fieldId: 'customfield_22014',
        fieldType: 'string',
        name: 'ONBOARDING Create',
        required: false,
        allowedValues: [],
      },
    ],
  },
  {
    id: 1,
    issueType: 'Non-Standard Hardware',
    fields: [
      {
        fieldId: 'attachment',
        fieldType: 'string',
        name: 'Attachment',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_10400',
        fieldType: 'string',
        name: 'User Security List',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_20630',
        fieldType: 'string',
        name: 'Hardware',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_23351',
        fieldType: 'string',
        name: 'Equipment Type',
        required: false,
        allowedValues: [
          'Laptop/PC',
          'Additional Hardware',
          'Accessories',
          'Additional hardware or accessories',
          'Ecoflow',
        ],
      },
      {
        fieldId: 'customfield_23352',
        fieldType: 'string',
        name: 'OS type',
        required: false,
        allowedValues: ['Windows', 'MacOS', 'Linux'],
      },
      {
        fieldId: 'customfield_23357',
        fieldType: 'string',
        name: 'Specify equipment',
        required: false,
        allowedValues: ['Spesify vendor, model, link'],
      },
      {
        fieldId: 'customfield_23360',
        fieldType: 'string',
        name: 'HelpDesk: Message',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'description',
        fieldType: 'string',
        name: 'Description',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'duedate',
        fieldType: 'string',
        name: 'Due Date',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'issuelinks',
        fieldType: 'string',
        name: 'Linked Issues',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'priority',
        fieldType: 'string',
        name: 'Priority',
        required: false,
        allowedValues: ['Blocker', 'High', 'Medium', 'Low', 'Minor'],
      },
      {
        fieldId: 'summary',
        fieldType: 'string',
        name: 'Summary',
        required: true,
        allowedValues: [],
      },
    ],
  },
  {
    id: 1,
    issueType: 'Standart Hardware',
    fields: [
      {
        fieldId: 'attachment',
        fieldType: 'string',
        name: 'Attachment',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_10400',
        fieldType: 'string',
        name: 'User Security List',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_20630',
        fieldType: 'string',
        name: 'Hardware',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_23351',
        fieldType: 'string',
        name: 'Equipment Type',
        required: false,
        allowedValues: [
          'Laptop/PC',
          'Additional Hardware',
          'Accessories',
          'Additional hardware or accessories',
          'Ecoflow',
        ],
      },
      {
        fieldId: 'customfield_23352',
        fieldType: 'string',
        name: 'OS type',
        required: false,
        allowedValues: ['Windows', 'MacOS', 'Linux'],
      },
      {
        fieldId: 'customfield_23353',
        fieldType: 'array',
        name: 'Hardware type',
        required: false,
        allowedValues: [
          'Laptop',
          'PC',
          'Monitor',
          'Graphic Tablet',
          'Cable (for charger, monitor or tec)',
          'Adaper',
          'Charger',
          'Mouse',
          'Keyboard',
          'Headphones',
          'Other',
        ],
      },
      {
        fieldId: 'customfield_23360',
        fieldType: 'string',
        name: 'HelpDesk: Message',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'description',
        fieldType: 'string',
        name: 'Description',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'duedate',
        fieldType: 'string',
        name: 'Due Date',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'issuelinks',
        fieldType: 'string',
        name: 'Linked Issues',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'priority',
        fieldType: 'string',
        name: 'Priority',
        required: false,
        allowedValues: ['Blocker', 'High', 'Medium', 'Low', 'Minor'],
      },
      {
        fieldId: 'summary',
        fieldType: 'string',
        name: 'Summary',
        required: true,
        allowedValues: [],
      },
    ],
  },
  {
    id: 1,
    issueType: 'CS Service request',
    fields: [
      {
        fieldId: 'attachment',
        fieldType: 'string',
        name: 'Attachment',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_10400',
        fieldType: 'string',
        name: 'User Security List',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_23602',
        fieldType: 'string',
        name: 'Request type',
        required: false,
        allowedValues: [
          'VPN',
          'CRM',
          'VOIP/SIP',
          'Chat',
          'Office-work',
          'Changing place in the office',
          'Other',
        ],
      },
      {
        fieldId: 'description',
        fieldType: 'string',
        name: 'Description',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'duedate',
        fieldType: 'string',
        name: 'Due Date',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'issuelinks',
        fieldType: 'string',
        name: 'Linked Issues',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'priority',
        fieldType: 'string',
        name: 'Priority',
        required: false,
        allowedValues: ['Blocker', 'High', 'Medium', 'Low', 'Minor'],
      },
      {
        fieldId: 'summary',
        fieldType: 'string',
        name: 'Summary',
        required: true,
        allowedValues: [],
      },
    ],
  },
  {
    id: 1,
    issueType: 'CS Hardware',
    fields: [
      {
        fieldId: 'attachment',
        fieldType: 'string',
        name: 'Attachment',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_10400',
        fieldType: 'string',
        name: 'User Security List',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'customfield_23351',
        fieldType: 'string',
        name: 'Equipment Type',
        required: false,
        allowedValues: [
          'Laptop/PC',
          'Additional Hardware',
          'Accessories',
          'Additional hardware or accessories',
          'Ecoflow',
        ],
      },
      {
        fieldId: 'customfield_23353',
        fieldType: 'array',
        name: 'Hardware type',
        required: false,
        allowedValues: [
          'Laptop',
          'PC',
          'Monitor',
          'Graphic Tablet',
          'Cable (for charger, monitor or tec)',
          'Adaper',
          'Charger',
          'Mouse',
          'Keyboard',
          'Headphones',
          'Other',
        ],
      },
      {
        fieldId: 'description',
        fieldType: 'string',
        name: 'Description',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'duedate',
        fieldType: 'string',
        name: 'Due Date',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'issuelinks',
        fieldType: 'string',
        name: 'Linked Issues',
        required: false,
        allowedValues: [],
      },
      {
        fieldId: 'priority',
        fieldType: 'string',
        name: 'Priority',
        required: false,
        allowedValues: ['Blocker', 'High', 'Medium', 'Low', 'Minor'],
      },
      {
        fieldId: 'summary',
        fieldType: 'string',
        name: 'Summary',
        required: true,
        allowedValues: [],
      },
    ],
  },
];
